import { useState } from "react";
import {
  ControlLayoutType,
} from "../types/RequestScreenContext.type";
import {
  DataSourceType,
  Form27TableAddRowDialog,
} from "../components/Form27TableAddRowDialog";

export function useForm27TableA({
  templateId,
  controlLayout,
  onChangeHandler,
}: Readonly<{
  templateId: number;
  controlLayout: ControlLayoutType;
  onChangeHandler: (values: DataSourceType[]) => void;
}>) {
  const TEMPLATE_ID = 27;
  const TABLE_NAME = "รายการสินค้า";

  if (
    TEMPLATE_ID != templateId ||
    TABLE_NAME != controlLayout?.template?.label
  ) {
    // nothing todo
    return;
  }

  const [visible, setVisible] = useState(false);
  const [memoIdRef, setMemoIdRef] = useState<any[]>([]);

  function openAddDialog() {
    setVisible(true);
  }

  function handleOnDismiss(
    onDismissCallback: (values: DataSourceType[]) => void
  ) {
    return (result: DataSourceType[]) => {
      setVisible(false);
      setMemoIdRef(result)
      onDismissCallback(result);
    };
  }
  function handleOnCancel(onCancelCallback?: () => void) {
    return () => {
      setVisible(false);
      onCancelCallback && onCancelCallback();
    };
  }

  return {
    isActive: true,
    openAddDialog: openAddDialog,
    component: {
      Form27TableAddRowDialog: Form27TableAddRowDialog.bind(null, {
        memoIdRef:memoIdRef,
        visible: visible,
        onDismiss: handleOnDismiss(onChangeHandler),
        onCancel: handleOnCancel(),
        memoIds: controlLayout?.custom?.memoIds ?? [],
        vendorName: controlLayout?.custom?.vendorName ?? "",
      }),
    },
  };
}
